import { Notification } from 'element-ui'

const isNewVersion = () => {
  let url = `/version.json?t=${Date.now()}`;
  window.fetch(url).then(response=>response.json()).then(res=>{
    let vueVersion = res.version;
    let localVueVersion = localStorage.getItem("vueVersion");
    localStorage.setItem("vueVersion", vueVersion);
    if (localVueVersion && localVueVersion !== vueVersion) {
      Notification.warning({
        title:"发现新版本",
        message:"新版本的应用程序已发布，请刷新页面更新",
        showClose:false,
        duration:0,
        onClick:()=>{
          window.location.reload();
        }
      })
    }
  })
};

export default {
  isNewVersion
};
